import React, { useEffect } from 'react';

/**
 * Modal estándar: clic fuera, Escape y botón × cierran (salvo busyWithoutClose).
 */
export default function InformeIvaModal({
  open,
  onClose,
  title,
  children,
  footer,
  maxWidth = 'max-w-lg',
  zIndex = 'z-[70]',
  busyWithoutClose = false
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape' && !busyWithoutClose) onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose, busyWithoutClose]);

  if (!open) return null;

  const tryClose = () => {
    if (!busyWithoutClose) onClose();
  };

  return (
    <div className={`fixed inset-0 ${zIndex} flex items-center justify-center p-4`} role="dialog" aria-modal="true">
      <button
        type="button"
        className="absolute inset-0 bg-black/45 cursor-default"
        aria-label="Cerrar"
        onClick={tryClose}
      />
      <div className={`relative bg-white rounded-2xl shadow-xl w-full ${maxWidth} max-h-[90vh] flex flex-col overflow-hidden`}>
        <div className="flex items-start justify-between gap-3 p-4 border-b shrink-0">
          <div className="min-w-0 flex-1">{title}</div>
          {!busyWithoutClose && (
            <button
              type="button"
              className="shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100 hover:text-slate-900"
              aria-label="Cerrar"
              onClick={onClose}
            >
              ×
            </button>
          )}
        </div>
        <div className="p-4 overflow-y-auto flex-1 min-h-0">{children}</div>
        {footer ? <div className="p-4 border-t shrink-0 bg-white">{footer}</div> : null}
      </div>
    </div>
  );
}
